import { BluebeamConnectProjectSettings } from '../backend/BackendBluebeamConnectSettings';
import { ForgeUser } from '../ForgeUser';
import { BluebeamCredentials } from './../../bluebeam/BluebeamAPI';
export class FrontendBluebeamConnectProjectSettings implements BluebeamConnectProjectSettings {
    public hubId: string = "";
    public projectId: string = "";
    public allowedUsers: ForgeUser[] = [];
    public inputFolderUrn: string = "";
    public inputFolderName: string = "";
    public outputFolderUrn: string = "";
    public outputFolderName: string = "";
    public massifClientId: string = "";
    public massifClientAssetId: string = "";
    public bluebeamProjectName: string = "";
    public bluebeamProjectId: string = "";
    public projectName: string = "";
}
